(function () {
  var hints = document.querySelectorAll('[data-nc-single-handle]');
  if (!hints.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(root + 'collections/mix-your-pack/products.json?limit=250', {
    headers: { Accept: 'application/json' },
  })
    .then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    })
    .then(function (data) {
      var buyable = new Set();
      (data.products || []).forEach(function (product) {
        var inStock = (product.variants || []).some(function (variant) {
          return variant.available;
        });
        if (inStock) buyable.add(product.handle);
      });

      hints.forEach(function (hint) {
        if (buyable.has(hint.dataset.ncSingleHandle)) hint.hidden = false;
      });
    })
    .catch(function () {});
})();
